import {ETPSubscriptionStatus} from "@/constants/IndividualTaxationConstants";
import {BankProductType} from "@/dto/company/OtherCompanyBankProductDTO";

export default class UpdateETPSubscriptionPayload {
    status?: ETPSubscriptionStatus;
    paymentMethod?: BankProductType;
    achAccountId?: number;
}